export enum AmbienteEnum {
  DEV = 'dev',
  QA = 'qa',
  OXY = 'oxy'
}
